import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges, ViewChild, ElementRef
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { SearchBy } from '@shared/base-search-bar/entities/search.entities';
import { SearchType } from '@search-bar/entities/search-type';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';
import {
  DataPickerChangedEvent, DataPickerModel
} from '@design-system/components/organisms/data-picker/entities/data-picker.types';
import { isEmpty } from '@app/util/util';

@Component({
  selector: 'app-search-bar-mobile-timepicker',
  templateUrl: './search-bar-mobile-timepicker.component.html',
  styleUrls: ['./search-bar-mobile-timepicker.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SearchBarMobileTimepickerComponent implements OnInit, OnDestroy, OnChanges {

  @ViewChild('timepickerMatrix') public timepickerMatrix: ElementRef;

  @Input() id: string = '';
  @Input() label: string;
  @Input() placeholder: string;
  @Input() title: string;
  @Input() control: UntypedFormControl;
  @Input() value: string;
  @Input() isMobile: boolean;
  @Input() eventPath: EventTarget[];
  @Input() showError: boolean;
  @Input() isHome: boolean;
  @Input() searchType: SearchType;
  @Input() disabled: boolean;

  @Output() timeSelection: EventEmitter<string> = new EventEmitter<string>();
  @Output() isShowed: EventEmitter<boolean> = new EventEmitter<boolean>();

  public show: boolean = false;
  public searchBy: string = SearchBy.AUTOS;
  public maxHeight: number = 80;
  public componentIdentifier: string = 'search-time-item-';
  public currentValue: string = '';
  public swapLabel: boolean = false;

  public readonly icons = Icon;

  public dataPickerModel: DataPickerModel[] = [];

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.currentValue = this.value;
    this.swapLabel = false;
    const arrTimes = this.populateTime(0, 23, 30);
    if (this.value !== '') {
      const idxTime = arrTimes.findIndex((t) => t === this.value);
      this.swapLabel = true;
      this.dataPickerModel = [
        {
          List: arrTimes.map((value) => ({ Id: value, Value: value })),
          CurrentIndex: idxTime >= 0 ? idxTime : null,
        }
      ];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.eventPath) {
      const inputButton = changes.eventPath.currentValue.find(paths =>
        !!paths['classList'] && paths['classList'].length > 0
        && paths['classList'].contains('search-bar-mobile-timepicker'));
      if (!inputButton && this.show) {
        this.toggle();
      }
    }
    this.swapLabel = (this.value !== '');
  }

  ngOnDestroy(): void {
    this.cdr.detach();
  }

  get swipeScrollStyles(): { [key: string]: string } {
    return this.isMobile ? { 'max-height': `${this.maxHeight}vh` } : {};
  }

  public toggle(state: boolean = !this.show): void {
    this.show = state;
    if (this.show) {
      this.isShowed.emit(this.show);
    }
    this.cdr.detectChanges();
  }

  public close(): void {
    this.toggle(false);
  }

  public applyTime(): void {
    this.timeSelection.emit(this.currentValue);
    this.close();
  }

  public updateTime(event: DataPickerChangedEvent): void {
    this.currentValue = event?.option?.Value;
    this.dataPickerModel[0].CurrentIndex = event?.selectedIndex;
    this.swapLabel = !isEmpty(event?.option?.Value);
  }

  private populateTime(from: number, to: number, interval: number): string[] {
    const arr: string[] = [];
    for (let i = from; i <= to; i++) {
      for (let j = 0; j < 60; j += interval) {
        const hour = i;
        const minutes = j;
        let text = hour < 10 ? `0${hour}` : `${hour}`;
        text += ':';
        text += minutes < 10 ? `0${minutes}` : `${minutes}`;
        arr.push(text);
      }
    }
    return arr;
  }

}
